import { render, staticRenderFns } from "./SpecialCard.vue?vue&type=template&id=5eca6870&"
import script from "./SpecialCard.vue?vue&type=script&lang=ts&"
export * from "./SpecialCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports